import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31f6d708"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=31f6d708&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f6d708')) {
      api.createRecord('31f6d708', component.options)
    } else {
      api.reload('31f6d708', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31f6d708", function () {
      api.rerender('31f6d708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/memberAskQuestions/list/index.vue"
export default component.exports